import { useState, useEffect } from 'react'
import { Clock } from 'lucide-react'

// Extraído literalmente de ChartPage.jsx (antes definido inline en ese
// archivo) para que ChartPublicPage.jsx tenga el mismo contador de cierre de
// vela. Puramente client-side (setInterval), sin ninguna dependencia de
// backend/trading.
export default function CandleCountdown({ timeframe }) {
  const [remaining, setRemaining] = useState('')

  useEffect(() => {
    const parseTf = (tf) => {
      const m = { m: 60, h: 3600, d: 86400, w: 604800, M: 2592000 }
      const g = tf.match(/(\d+)([mhdwM])/)
      if (!g) return 3600
      return parseInt(g[1], 10) * m[g[2]]
    }

    const update = () => {
      const sec = parseTf(timeframe)
      const now = Date.now()
      const nextClose = Math.ceil(now / 1000 / sec) * sec * 1000
      const totalSec = Math.max(0, Math.floor((nextClose - now) / 1000))
      const h = Math.floor(totalSec / 3600)
      const m = Math.floor((totalSec % 3600) / 60)
      const s = totalSec % 60
      if (h > 0) {
        setRemaining(`${h}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`)
      } else {
        setRemaining(`${m}:${String(s).padStart(2, '0')}`)
      }
    }

    update()
    const id = setInterval(update, 1000)
    return () => clearInterval(id)
  }, [timeframe])

  return (
    <div
      className="flex items-center gap-1.5 px-2.5 py-1.5 bg-white dark:bg-gray-800 border border-slate-200 dark:border-gray-700 rounded-lg text-xs font-mono text-slate-600 dark:text-gray-300"
      title="Tiempo hasta el cierre de la vela actual"
    >
      <Clock size={12} />
      {/* Ancho fijo (8ch = "HH:MM:SS") + tabular-nums + text-right: al cruzar
          la hora el string pasa de H:MM:SS a M:SS y sin esto el ancho del
          contenedor saltaría, moviendo el resto del header. */}
      <span className="inline-block text-right tabular-nums" style={{ minWidth: '8ch' }}>{remaining}</span>
    </div>
  )
}
